import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button, DatePicker } from "antd";
import { columnsDataComplex } from "./variables/columnsData";
import { tableDataComplex } from "./variables/tableDataComplex";
import CommonTable from "components/common/CommonTable";

const processData = (data) => {
  return data.map((item, index) => ({
    ...item,
    key: index,
    answer: item.answer.replace(/<\/?p>/g, ""),
  }));
};

const CustomDatePickerInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
  <button 
    className="w-full rounded-md border bg-white py-1.5 px-3 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" 
    onClick={onClick} 
    ref={ref}
  >
    {value || placeholder}
  </button>
));

const Tables = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(processData(tableDataComplex));
  }, []);

  const handleFilter = () => {
    if (startDate && endDate) {
      const filtered = tableDataComplex.filter(item => {
        const itemDate = new Date(item.created_at);
        // Adjust to include the entire end day
        const endOfDay = new Date(endDate);
        endOfDay.setHours(23, 59, 59, 999);
        return itemDate >= startDate && itemDate <= endOfDay;
      });
      setFilteredData(processData(filtered));
    } else {
      // Optionally, show an alert or handle the case where dates are not selected
      setFilteredData(processData(tableDataComplex)); // Or clear the filter
    }
  };

  return (
    <div>
      <div className="mt-3 flex justify-between items-center gap-4">
        <div className="text-[30px] font-bold font-figtree chatbot-text" style={{ fontFamily: "figtree" }}>
          <h1>Logs</h1>
        </div>
        <div className="flex items-center gap-4">
          <DatePicker
            placeholder="Start Date"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            customInput={<CustomDatePickerInput placeholder="Start Date" />}
            calendarClassName="calendar_custom"
          />
          <DatePicker
            placeholder="End Date"
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            customInput={<CustomDatePickerInput placeholder="End Date" />}
            calendarClassName="calendar_custom"
          />
          <Button
            className="rounded-md bg-[#2369d2] py-2 px-4 text-sm font-medium text-white"
            style={{ fontFamily: "figtree" }}
            onClick={handleFilter}
          >
            Fetch Data
          </Button>
        </div>
      </div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <CommonTable
          columns={columnsDataComplex}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          style={{ fontFamily: "figtree" }}
        />
      </div>
    </div>
  );
};

export default Tables;
